module.exports = __webpack_public_path__ + "img/bedroom_comp_001_thumb.aa95aa4a.jpg";